import { type MouseEvent } from 'react'

import bannedImg from '@/assets/images/banned.webp'
import unofficialImg from '@/assets/images/unofficial.webp'
import { LinkRoute } from '@/components/common/Link'
import { Icon } from '@/components/icons/Icon'
import { type InViewStatus } from '@/hooks/useInView'

import styles from './CardFace.module.scss'
import { CardFaceWarning } from './CardFaceWarning/CardFaceWarning'

type Props = {
  hasContentWarning?: boolean
  hasError?: boolean
  href?: string
  image?: string
  inViewStatus?: InViewStatus
  isBanned?: boolean
  isUnofficial?: boolean
  loading?: boolean
  name?: string
  onClick?: (e: MouseEvent<HTMLElement>) => void
}

export const CardFace = ({
  hasContentWarning,
  hasError,
  href,
  image,
  inViewStatus = 'inView',
  isBanned,
  isUnofficial,
  loading,
  name,
  onClick: onClickProp,
}: Props) => {
  const Element = href ? LinkRoute : 'div'
  const onClick = href ? onClickProp : undefined

  return (
    <Element className={styles.container} href={href} onClick={onClick}>
      {inViewStatus !== 'outside' && !loading && image && (
        <img alt='' className={styles.image} role='presentation' src={image} />
      )}
      <span className={styles.name}>{name || 'Card Name'}</span>
      {isBanned ? (
        <span className={styles.banned}>
          <img alt='Banned' decoding='async' loading='lazy' src={bannedImg.src} />
        </span>
      ) : (
        isUnofficial && (
          <span className={styles.unofficial}>
            <img alt='Unofficial' decoding='async' loading='lazy' src={unofficialImg.src} />
          </span>
        )
      )}
      {hasContentWarning && <CardFaceWarning />}
      {hasError && (
        <span className={styles.error}>
          <Icon name='ban' />
          <span className={styles.errorTitle}>Error</span>
          <span>We had trouble loading this card, try refreshing the page.</span>
        </span>
      )}
    </Element>
  )
}
